module.exports = __webpack_public_path__ + "dbe2c3bd1b0d036c7c3159259ca2d43c.ttf";